<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M16.129 6.34982L12.83 3.38073C11.8902 2.53484 11.4203 2.11189 10.8436 1.89062L10.8359 4.16937C10.8359 6.13355 10.8359 7.11564 11.4461 7.72583C12.0564 8.33603 13.0384 8.33603 15.0026 8.33603H17.986C17.6839 7.74918 17.1429 7.26231 16.129 6.34982Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.33463 18.3346H11.668C14.8106 18.3346 16.382 18.3346 17.3583 17.3583C18.3346 16.382 18.3346 14.8106 18.3346 11.668V11.3037C18.3346 10.5764 18.3346 10.03 18.2991 9.58472H15.0013H14.9222C14.008 9.5848 13.2001 9.58488 12.5487 9.4973C11.8428 9.40238 11.137 9.18447 10.561 8.60838C9.98488 8.03235 9.76697 7.32653 9.67205 6.6206C9.58447 5.96933 9.58455 5.16136 9.58463 4.24711L9.5923 1.88511C9.59255 1.81641 9.59847 1.74846 9.60963 1.68185C9.26913 1.66797 8.86447 1.66797 8.35947 1.66797C5.20021 1.66797 3.62059 1.66797 2.64428 2.64428C1.66797 3.62059 1.66797 5.19193 1.66797 8.33463V11.668C1.66797 14.8106 1.66797 16.382 2.64428 17.3583C3.62059 18.3346 5.19193 18.3346 8.33463 18.3346ZM6.65717 15.874C6.89758 16.0993 7.27168 16.0993 7.5121 15.874L9.1788 14.3115C9.43055 14.0754 9.44338 13.6798 9.2073 13.428C8.97122 13.1762 8.57563 13.1634 8.32383 13.3995L7.70963 13.9753V11.2513C7.70963 10.9061 7.42981 10.6263 7.08463 10.6263C6.73946 10.6263 6.45963 10.9061 6.45963 11.2513V13.9753L5.84543 13.3995C5.59361 13.1634 5.19809 13.1762 4.96201 13.428C4.72593 13.6798 4.73868 14.0754 4.9905 14.3115L6.65717 15.874Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'DownloadManualIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>